import { Role, rolesManipulator, useGetAccessTokenPayload } from 'auth';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { REGISTER_ID_SEARCH_PARAM_KEY } from '@/modules/common/constants/search-params.ts';
import { PageLayout, Spinner } from 'ui';

const AI_CHAT_URL = import.meta.env.VITE_AI_CHAT_URL;

const IssuerAIChat = () => {
  const [loading, setLoading] = useState(true);
  const { refreshToken } = useGetAccessTokenPayload();
  const [token] = useState<string>(refreshToken ?? '');
  const [params] = useSearchParams();
  const register = params.get(REGISTER_ID_SEARCH_PARAM_KEY);
  const userRole = rolesManipulator.current_user_role as Role;

  useEffect(() => {
    const streamlitOrigin = new URL(AI_CHAT_URL).origin;

    const handleMessage = (event: MessageEvent<{ type?: string }>) => {
      if (event.origin !== streamlitOrigin || event.data?.type !== 'REQUEST_TOKEN') return;

      (event.source as WindowProxy | null)?.postMessage(
        { type: 'TOKEN_RESPONSE', token },
        streamlitOrigin,
      );
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, [token]);

  return (
    <PageLayout
      title={
        <span className="flex items-center gap-3">
          AI Chat <BetaBadge />
        </span>
      }
    >
      <div className="flex flex-col gap-6 w-full min-h-full">
        {loading && (
          <div className="w-full h-full flex items-center justify-center">
            <Spinner size="lg" />
          </div>
        )}

        <iframe
          className="w-full h-full overflow-hidden"
          src={`${AI_CHAT_URL}?role=${userRole}&register_id=${register}`}
          allow="camera; microphone; clipboard-write; geolocation"
          onLoad={() => setLoading(false)}
        ></iframe>
      </div>
    </PageLayout>
  );
};

export const BetaBadge = () => {
  return (
    <span
      className="px-2.5 py-0.5 text-xs font-[Inter] font-medium rounded-full text-white shadow-md"
      style={{
        background: 'linear-gradient(90deg, #1E5984, #24699F, #2E84C5, #3DA4E7)',
      }}
    >
      Beta
    </span>
  );
};

export default withPrivateAccess(IssuerAIChat, [Role.SR_ISSUER, Role.SR_ISSUER_ADMIN]);
